module.exports = __webpack_public_path__ + "static/msu.1bdafbac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/msu.png
// module id = 2189
// module chunks = 61762850755587